import { Page } from 'compositions/Page'

import { CustomerioImportsSection } from '../settings/customerio-imports-section'

export function AdminImports() {
  return (
    <Page>
      <h1 className="mb-6 text-xl font-semibold">Imports</h1>
      <CustomerioImportsSection />
    </Page>
  )
}
